import React from 'react';
import { StarIcon } from 'lucide-react';
export function ReviewFab() {
  return <a href="#top" className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-brand-red px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-black/40 transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-redDark" data-id="element-164" data-mp="389ldi254gpew">
      <StarIcon className="h-4 w-4 fill-white" aria-hidden="true" data-id="element-165" data-mp="2l9vvryjqgy8p" />
      Leave a review
    </a>;
}